import { camelizeKeys } from 'humps';
import {
  SHOW_LOADER,
  CONFIGURE_ALERT,
  CONFIGURE_SNACKBAR,
  SET_FILTERS,
  SET_VIEW_CONFIGURATION,
  SET_CURRENCY,
  SET_CURRENCY_SUFFIX
} from './mutation-types'

import { getViewConfigurationByProviderSlug } from '@/services/rcm-api.service';

const showLoader = ({commit}, payload) => {
  commit(SHOW_LOADER, payload)
}

const configureAlert = ({commit}, payload) => {
  commit(CONFIGURE_ALERT, payload)
}

const configureSnackbar = ({ commit }, payload) => {
  commit(CONFIGURE_SNACKBAR, payload)
}

const setFilter = ({ commit }, payload) => {
  commit(SET_FILTERS, payload)
}

const removeFilter = ({ commit, state }, payload) => {
  const inputs = state.filters;
  const inputsFiltered = inputs.filter(input => input.slug != payload)
  commit(SET_FILTERS, inputsFiltered)
}

const fetchViewConfiguration = async ({ commit }, providerSlug) => {
  try {
    const response = await getViewConfigurationByProviderSlug(providerSlug);
    const viewConfiguration = camelizeKeys(response.data);

    if (viewConfiguration) {
      localStorage.setItem('viewConfiguration', JSON.stringify(viewConfiguration));
      commit(SET_VIEW_CONFIGURATION, viewConfiguration);
    }
  } catch (error) {
    console.log("Error al obtener la configuración de la vista:", error);
  }
};

const loadViewConfigurationFromStorage = ({ commit }) => {
  const viewConfiguration = localStorage.getItem('viewConfiguration');
  const parsedViewConfiguration = viewConfiguration ? JSON.parse(viewConfiguration) : null;
  const countryCode = parsedViewConfiguration?.providerCountry?.toUpperCase() || 'co';

  if (parsedViewConfiguration) {
    commit(SET_VIEW_CONFIGURATION, parsedViewConfiguration);
  }
  commit(SET_CURRENCY, countryCode);
  commit(SET_CURRENCY_SUFFIX, countryCode);
};

export default {
  showLoader,
  configureAlert,
  configureSnackbar,
  setFilter,
  removeFilter,
  fetchViewConfiguration,
  loadViewConfigurationFromStorage
}
